import React from 'react';
import { Field, reduxForm } from 'redux-form'
import { Button } from 'reactstrap';

import { renderField, validate } from '../../helpers/validation.helper';

const AuthPageForm  = props => {
    const { handleSubmit } = props;

    return (
        <form onSubmit={handleSubmit}>
            <div className="container-fluid">
                <div className="row">

                    <div className="center-form">
                        <Field
                            id="email"
                            name="email"
                            type="text"
                            placeholder="Email"
                            component={renderField}
                        />
                        <Field
                            id="password"
                            name="password"
                            type="password"
                            placeholder="Parola"
                            component={renderField}
                        />
                        <div className="control">
                            <Button className="btn-cinemap-blue btn-landing btn btn-secondary btn-lg" type="submit">Loghează-te</Button>
                        </div>
                    </div>

                </div>
            </div>

        </form>
    )

};

export default reduxForm({
    form: 'loginForm', // a unique identifier for this form,
    validate: validate('loginForm')
})(AuthPageForm)



// WEBPACK FOOTER //
// ./src/SHARED/components/auth/authpageform.component.js